import LocalPanel from "components/Modal/ChooseFilesModal/Browser/LocalPanel";
import { FILE_SOURCES } from "layout/documentUploader/constants";
import { func, string } from "prop-types";
import { useSelector } from "react-redux";
import { selectChooseFilesModal } from "slices/workspace/selectors";

import { allowedExtensionsProp } from "../propTypes";
import SharepointPanel from "../Sharepoint/SharepointPanel";

const Browser = ({ allowedExtensions, target, processFiles }) => {
  const { activeSource } = useSelector(selectChooseFilesModal);

  const handleFilesSelected = (files) => {
    processFiles(files);
  };

  return (
    <div data-testid="choose-files-modal-body-browser">
      {activeSource === FILE_SOURCES.LOCAL && (
        <LocalPanel
          allowedExtensions={allowedExtensions}
          onFilesSelected={handleFilesSelected}
          target={target}
        />
      )}
      {activeSource === FILE_SOURCES.SHAREPOINT && (
        <SharepointPanel onSelected={handleFilesSelected} target={target} />
      )}
    </div>
  );
};

Browser.propTypes = {
  allowedExtensions: allowedExtensionsProp,
  target: string.isRequired,
  processFiles: func.isRequired,
};

export default Browser;
